<div class="modal" *ngIf="isVisible">
  <div class="modal-content">
    <div class="loader" ></div>
    <p *ngIf="!isLoading">{{ 'REDIRECTION_IN_PROGRESS' | translate }}</p>
  </div>
</div>